/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_LiveInputs */

const th_nav_live = /** @type {(inputs: Nav_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังแข่ง`)
};

const en_nav_live = /** @type {(inputs: Nav_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live now`)
};

const ja_nav_live = /** @type {(inputs: Nav_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`試合中`)
};

const zh_nav_live = /** @type {(inputs: Nav_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`直播`)
};

const es_nav_live = /** @type {(inputs: Nav_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En directo`)
};

const pt_nav_live = /** @type {(inputs: Nav_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ao vivo`)
};

const id_nav_live = /** @type {(inputs: Nav_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langsung`)
};

const fr_nav_live = /** @type {(inputs: Nav_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En direct`)
};

const tl_nav_live = /** @type {(inputs: Nav_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live`)
};

const vi_nav_live = /** @type {(inputs: Nav_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trực tiếp`)
};

const ko_nav_live = /** @type {(inputs: Nav_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`실시간`)
};

const de_nav_live = /** @type {(inputs: Nav_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live`)
};

const ru_nav_live = /** @type {(inputs: Nav_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эфир`)
};

const tr_nav_live = /** @type {(inputs: Nav_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canlı`)
};

const it_nav_live = /** @type {(inputs: Nav_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In diretta`)
};

const pl_nav_live = /** @type {(inputs: Nav_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na żywo`)
};

const uk_nav_live = /** @type {(inputs: Nav_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ефір`)
};

const hi_nav_live = /** @type {(inputs: Nav_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लाइव`)
};

const ar_nav_live = /** @type {(inputs: Nav_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مباشر`)
};

const ms_nav_live = /** @type {(inputs: Nav_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langsung`)
};

const bn_nav_live = /** @type {(inputs: Nav_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সরাসরি`)
};

const zh_tw2_nav_live = /** @type {(inputs: Nav_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`直播`)
};

const zh_hk2_nav_live = /** @type {(inputs: Nav_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`直播`)
};

const ur_nav_live = /** @type {(inputs: Nav_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`براہ راست`)
};

const fa_nav_live = /** @type {(inputs: Nav_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`زنده`)
};

const sw_nav_live = /** @type {(inputs: Nav_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moja kwa moja`)
};

const nl_nav_live = /** @type {(inputs: Nav_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live`)
};

/**
* | output |
* | --- |
* | "Live now" |
*
* @param {Nav_LiveInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const nav_live = /** @type {((inputs?: Nav_LiveInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_LiveInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_nav_live(inputs)
	if (locale === "ja") return ja_nav_live(inputs)
	if (locale === "zh") return zh_nav_live(inputs)
	if (locale === "es") return es_nav_live(inputs)
	if (locale === "pt") return pt_nav_live(inputs)
	if (locale === "id") return id_nav_live(inputs)
	if (locale === "fr") return fr_nav_live(inputs)
	if (locale === "tl") return tl_nav_live(inputs)
	if (locale === "vi") return vi_nav_live(inputs)
	if (locale === "ko") return ko_nav_live(inputs)
	if (locale === "de") return de_nav_live(inputs)
	if (locale === "ru") return ru_nav_live(inputs)
	if (locale === "tr") return tr_nav_live(inputs)
	if (locale === "it") return it_nav_live(inputs)
	if (locale === "pl") return pl_nav_live(inputs)
	if (locale === "uk") return uk_nav_live(inputs)
	if (locale === "hi") return hi_nav_live(inputs)
	if (locale === "ar") return ar_nav_live(inputs)
	if (locale === "ms") return ms_nav_live(inputs)
	if (locale === "bn") return bn_nav_live(inputs)
	if (locale === "zh-TW") return zh_tw2_nav_live(inputs)
	if (locale === "zh-HK") return zh_hk2_nav_live(inputs)
	if (locale === "ur") return ur_nav_live(inputs)
	if (locale === "fa") return fa_nav_live(inputs)
	if (locale === "sw") return sw_nav_live(inputs)
	if (locale === "nl") return nl_nav_live(inputs)
	return en_nav_live(inputs)
});